import api from '@/helpers/api';

export default {
  fetchIntegrations({ commit }, merchantId) {
    commit('START_LOADING_INTEGRATIONS');
    api('GET', `/merchants/${merchantId}/integrations`)
      .then((response) => {
        if (response.status === 200) {
          commit('SET_INTEGRATIONS', response.data);
        }
      })
      .catch((error) => {
        commit('API_ERROR', error.response);
      });
  },
  deleteIntegration({ commit }, payload) {
    api('DELETE', `/merchants/${payload.merchant_id}/integrations/${payload.integration_id}`)
      .then((response) => {
        if (response.status === 200) {
          commit('INTEGRATION_DELETED', payload.integration_id);
        }
      })
      .catch((error) => {
        commit('API_ERROR', error.response);
      });
  },
  fetchFrontToken({ commit }, payload) {
    commit('START_LOADING_FRONT_TOKEN');
    api('GET', `/integrations/front/token/${payload.data.code}`)
      .then((response) => {
        if (response.status === 200) {
          commit('SET_FRONT_TOKEN', response.data);
        }
      })
      .catch((error) => {
        commit('API_ERROR', error.response);
      });
  },
  fetchFrontTeamList({ commit }, payload) {
    commit('START_LOADING_FRONT_TEAMS');
    api('GET', `/merchants/${payload.merchant_id}/integrations/front/teams`, payload.data)
      .then((response) => {
        if (response.status === 200) {
          commit('SET_FRONT_TEAMS_LIST', response.data);
        }
      })
      .catch((error) => {
        commit('API_ERROR', error.response);
      });
  },
  integrateFront({ commit }, payload) {
    commit('SET_FRONT_INTEGRATED', false);
    api('POST', `/merchants/${payload.merchant_id}/integrations/front`, payload.data)
      .then((response) => {
        if (response.status === 200) {
          commit('SET_FRONT_INTEGRATED', true);
        }
      })
      .catch((error) => {
        commit('API_ERROR', error.response);
      });
  },
  deleteFrontChannel({ commit, rootState }, frontChannel) {
    const request = api('DELETE', `organisation/${rootState.organisation.currentOrganisation.id}/integrations/${frontChannel.integration_id}`, { type: 'FRONTPACHA' }, null, 'w');
    request
      .then((response) => {
        if (response.status === 200) {
          commit('organisation/REMOVE_INTEGRATION', { type: 'FRONTPACHA', frontChannel }, { root: true });
        }
      });
    return request;
  },
  deleteAllFrontChannels({ commit, rootState }, numberId) {
    const request = api('DELETE', `organisation/${rootState.organisation.currentOrganisation.id}/integrations`, { type: 'FRONTPACHA', business_id: numberId }, null, 'w');
    request
      .then((response) => {
        if (response.status === 200) {
          commit('organisation/REMOVE_INTEGRATION', { type: 'FRONTPACHA', numberId }, { root: true });
        }
      });
    return request;
  },
};
